export enum ReportTemplateApplyColumn {
    NAME = "name",
    CURRENT_TEMPLATE = "currentTemplate",
    NEW_TEMPLATE = "newTemplate",
    OVERRIDES = "overrides",
}
